import React, { useEffect, useRef, useState } from "react";
import { Table } from "antd";

import './DataGrid.css';
import SearchText from "../SearchText/SearchText";
import { COLORS } from "../../constants/colors";
import ActionsGrid from "../ActionsGrid/ActionsGrid";
import { IMenu } from "../../../interfaces/IMenu";
import IAction from "../../../interfaces/IAction";
import IColumn from "../../../interfaces/IColumn";



interface Props {
    columns: IColumn[];
    dataSource: any[];
    menu: IMenu;
    loading: boolean;
    addAction?: IAction;
    updateAction?: IAction;
    deleteAction?: IAction;
    copyAction?:IAction;
    linkUserAction?: IAction;
    linkQuestionAction?: IAction;
    gridProps?: any;
    setItemSelected: any;
    searchMethod: (value: string) => void;
    selectedRowKeys: React.Key[];
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>;
    searchV: string;
}

const DataGrid = ({ searchV, columns, dataSource, menu, addAction, updateAction, deleteAction, copyAction, linkUserAction, linkQuestionAction, loading, gridProps, setItemSelected, selectedRowKeys, setSelectedRowKeys, searchMethod }: Props): JSX.Element => {

    const handleSelectRow = (keys: React.Key[], item: any) => {
        setItemSelected(item);
        setSelectedRowKeys(keys);
    }

    const handleClearSelection = () => {
        setSelectedRowKeys([]);
        setItemSelected(null);
    }

    const handleSearch = (value: string) => {
        if (selectedRowKeys.length > 0) {
            handleClearSelection();
        }
        searchMethod(value);
    }

    return (
        <div className="grid">
            <div className="grid_header">
                <div className="grid_search">
                    <SearchText
                        value={searchV}
                        active={true}
                        borderColor={COLORS.black_back_color5}
                        textColor={COLORS.black_text_color1}
                        placeholdercolor={COLORS.black_text_color4}
                        name={"search_table"}
                        onChange={handleSearch}
                        placeholder={"Buscar"}
                        backgroundcolor={COLORS.black_back_color5}
                        opacity={1}
                        props={{ collapsed: 'false' }}
                    />
                </div>
                <ActionsGrid
                    menu={menu}
                    addAction={addAction}
                    updateAction={updateAction}
                    deleteAction={deleteAction}
                    copyAction={copyAction}
                    linkUserAction={linkUserAction}
                    linkQuestionAction={linkQuestionAction}
                />
            </div>
            <Table
                {...gridProps}
                dataSource={dataSource}
                rowSelection={{ type: 'radio', onChange: (keys, rows) => handleSelectRow(keys, rows[0]), selectedRowKeys }}
                columns={columns}
                scroll={{ y: '60vh' }}
                loading={loading}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: false,
                    total: Number(gridProps?.pagination?.total) || dataSource.length,
                    current: Number(gridProps?.pagination?.current) || 1,
                  }}
            />
        </div>
    );
}


export default DataGrid;